import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import './Pages.css';
import SEOMetaTags from '../common/SEOMetaTags';

const AboutUs = () => {
  return (
    <>
      <SEOMetaTags 
        title="About NM Diamond | Our Story & Values"
        description="Learn about NM Diamond's journey from a family business to Delhi's premier diamond jewelry wholesaler. Discover our commitment to quality, ethical sourcing, and exceptional craftsmanship."
        keywords="NM Diamond history, diamond jewelry wholesaler Delhi, ethical diamond sourcing, diamond jewelry craftsmanship, premium diamond quality, Karol Bagh jewelers"
        canonicalUrl="https://www.nmdiamond.in/about"
        ogImage="https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
      />
      <Container className="page-container">
        <Row className="page-header">
          <Col>
            <h1>About NM Diamond</h1>
          </Col>
        </Row>
        
        <div className="about-section">
          <Row className="page-content">
            <Col md={6} className="mb-4">
              <div className="about-image">
                <Image 
                  src="https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                  alt="NM Diamond Jewelry Collection" 
                  fluid 
                />
              </div>
            </Col>
            <Col md={6} className="about-content">
              <h2>Our Story</h2>
              <p>
                Founded in 2010, NM Diamond has established itself as a premier destination for exquisite diamond jewelry. 
                Our journey began with a simple vision: to provide customers with exceptional quality diamonds at fair prices.
              </p>
              <p>
                What started as a small family business has evolved into a respected name in the diamond industry. Our founder, 
                Nikhil Mehta, combined his passion for gemology with his family's three-generation legacy in jewelry craftsmanship 
                to create a brand that stands for quality, transparency, and artistry.
              </p>
              <p>
                Today, we serve customers across India and beyond, bringing the timeless elegance of diamond jewelry to 
                discerning clients who appreciate both traditional and contemporary designs.
              </p>
            </Col>
          </Row>
        </div>
        
        <div className="mission-section">
          <Row>
            <Col>
              <h2>Our Mission</h2>
              <p>
                At NM Diamond, our mission is to make the beauty and elegance of diamond jewelry accessible to everyone. 
                We believe that every piece of jewelry tells a story, and we are committed to helping our customers find 
                pieces that reflect their unique style and personality while maintaining the highest standards of quality and craftsmanship.
              </p>
            </Col>
          </Row>
        </div>
        
        <div className="about-section">
          <Row className="mt-5">
            <Col md={6} className="about-content order-md-1">
              <h2>Our Commitment to Quality</h2>
              <p>
                We take pride in offering only the finest quality diamonds, each carefully selected for its cut, clarity, 
                color, and carat weight. Our team of experienced gemologists ensures that every diamond meets our rigorous 
                standards before it becomes part of our collection.
              </p>
              <p>
                All our jewelry is crafted with meticulous attention to detail, using only the finest materials. 
                We stand behind the quality of our products with a satisfaction guarantee, ensuring that each piece 
                will be treasured for generations to come.
              </p>
              <p>
                Our commitment extends beyond just selling beautiful jewelry. We provide comprehensive after-sales service, 
                including cleaning, maintenance, and repairs, to ensure your precious pieces remain as stunning as the day 
                you acquired them.
              </p>
            </Col>
            <Col md={6} className="mb-4 order-md-2">
              <div className="about-image">
                <Image 
                  src="https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                  alt="Diamond Jewelry Craftsmanship" 
                  fluid 
                />
              </div>
            </Col>
          </Row>
        </div>
        
        <div className="values-section">
          <Row>
            <Col>
              <h2>Our Values</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <ul className="values-list">
                <li>
                  <strong>Integrity</strong>
                  <p>We conduct our business with honesty and transparency, ensuring that our customers can trust us completely.</p>
                </li>
                <li>
                  <strong>Excellence</strong>
                  <p>We strive for excellence in everything we do, from the selection of our diamonds to the craftsmanship of our jewelry.</p>
                </li>
                <li>
                  <strong>Customer Focus</strong>
                  <p>Our customers are at the heart of our business. We listen to their needs and provide personalized service.</p>
                </li>
                <li>
                  <strong>Innovation</strong>
                  <p>We continuously seek new ways to improve our products and services, blending traditional craftsmanship with modern techniques.</p>
                </li>
                <li>
                  <strong>Sustainability</strong>
                  <p>We are committed to ethical sourcing and environmentally responsible practices throughout our supply chain.</p>
                </li>
                <li>
                  <strong>Community</strong>
                  <p>We believe in giving back to the communities where we operate, supporting local initiatives and charitable causes.</p>
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default AboutUs; 